<script>
    import * as Common from './Common.js'
    import { getContext, onMount } from 'svelte';
    import {push, pop, replace} from './pt-router/Router.svelte'
    
    let email = ""

    onMount(() => {
        if(Common.currentUserValue) {
            push('/account')
            return
        }
    })

    function submit() {
        Common.postData('/unsubscribe?email=' + email)
        .then(r => {
            if(!r.ok) {
                alert("Problem unsubscribing! Please contact us.")
                return
            }

            Common.CreateNotification({body: "You are now unsubscribed from all area emails!"}, 1000)
            push('/')
        })
    }
</script>

<h1>Unsubscribe From Area Updates</h1>
<p>
    If you want to unsubscribe from area updates, simply input your email into the following field and click the 'Submit' button.
</p>
<p>
    If you have an account and want to unsubscribe from the main newsletter and inbox notifications, please <a href="#/login">login</a> and disable them.
</p>
<p>
    <input type="email" placeholder="Email" bind:value={email}>
    <button on:click={submit}>Submit</button>
</p>